import React from "react";
import { Clock } from "lucide-react";
import { TimeCard } from "./TimeCard";

interface ShiftTimesSectionProps {
  loggedStartTime: string;
  actualArrivalTime: string;
  manualArrivalTime?: string | null;
  arrivalTimeApprovedBy?: number | null;
  loggedEndTime?: string;
  actualEndTime?: string;
  manualEndTime?: string | null;
  endTimeApprovedBy?: number | null;
  /** Current time string e.g. "05:15 PM" */
  currentTime?: string;
  /** When set (e.g. overnight shift), show this date in the current time box */
  currentTimeDate?: string;
}

export function ShiftTimesSection({
  loggedStartTime,
  actualArrivalTime,
  manualArrivalTime,
  arrivalTimeApprovedBy,
  loggedEndTime,
  actualEndTime,
  manualEndTime,
  endTimeApprovedBy,
  currentTime,
  currentTimeDate,
}: ShiftTimesSectionProps) {
  return (
    <section className="bg-blue-500 rounded-b-3xl p-4 relative overflow-hidden">
      {/* Top Row - Logged Start and Actual Arrival */}
      <div className="grid grid-cols-2 gap-3 mb-3">
        <TimeCard
          label="Logged Start"
          time={loggedStartTime}
        />
        <TimeCard
          label="Actual Arrival"
          time={actualArrivalTime}
          manualTime={manualArrivalTime}
          approvedBy={arrivalTimeApprovedBy}
        />
      </div>

      {/* Bottom Row - Logged End and Actual End (if provided) */}
      {loggedEndTime && actualEndTime && (
        <div className="grid grid-cols-2 gap-3 mb-3">
          <TimeCard
            label="Logged End"
            time={loggedEndTime}
          />
          <TimeCard
            label="Actual End"
            time={actualEndTime}
            manualTime={manualEndTime}
            approvedBy={endTimeApprovedBy}
          />
        </div>
      )}

      {/* Current Time Card - Large Blue Card (if provided) */}
      {currentTime && (
        <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/20">
          <p className="text-xs text-gray-200 mb-1">Current Time</p>
          {currentTimeDate && (
            <p className="text-sm text-gray-200 mb-0.5">{currentTimeDate}</p>
          )}
          <p className="text-3xl font-bold text-white">{currentTime}</p>
        </div>
      )}
    </section>
  );
}

